<template>
  <div class="form form-inner">
    <div class="form-item">
      <span class="label"><i class="required">*</i>服务区域：</span>
      <div class="input-box">
        <div class="input address-input" @click="pickMap">{{form.FullAddress}}</div>
        <svg class="icon icon-location" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2987"><path d="M474.129 65.929c-153.213 16.689-277.43 138.728-296.656 291.644-9.901 78.748 7.502 152.922 43.861 214.584 71.595 150.11 214.528 316.671 269.5 377.995 11.882 13.255 32.546 13.347 44.428 0.092 57.923-64.616 213.866-246.527 280.641-402.671 21.381-44.289 33.37-93.963 33.37-146.439-0.001-198.748-171.909-357.343-375.144-335.205z m67.511 504.399c-117.27 14.78-215.888-83.842-201.106-201.11 10.072-79.901 74.595-144.422 154.497-154.491 117.266-14.777 215.881 83.839 201.103 201.106-10.07 79.902-74.592 144.425-154.494 154.495z" p-id="2988"></path></svg>
      </div>
    </div>
    <div class="form-item">
      <span class="label">门牌号：</span>
      <div class="input-box">
        <input type="text" class="input" v-model.trim="form.Address">
      </div>
    </div>
    <div class="form-item">
      <span class="label"><i class="required">*</i>现场联系人：</span>
      <div class="input-box">
        <input type="text" class="input" v-model.trim="form.ContactsName">
      </div>
    </div>
    <div class="form-item">
      <span class="label"><i class="required">*</i>电话号码：</span>
      <div class="input-box">
        <input type="text" class="input" v-model.trim="form.ContactsPhone">
      </div>
    </div>
    <div class="btn-primary" @click="submit">确定</div>
  </div>
</template>
<script>
import valid from '@/scripts/validate.js'
import Bus from '@/scripts/bus.js'
import {
  AddJobAddress,
  UpdateJobAddress,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  props:{
    item:{
      type:Object,
      default(){
        return{}
      }
    }
  },
  data(){
    return{
      editId:0,
      form:{
        CityName:'',
        Lng:'',
        Lat:'',
        Address:'',
        ContactsName:'',
        ContactsPhone:'',
        FullAddress:'',
      }
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  watch:{
    item:{
      handler(value){
        if(value.ID){
          this.editId=value.ID;
          for (const k in this.form) {
            this.form[k] = value[k];
          }
        }else{
          this.editId=0;
          this.form={
            CityName:'',
            Lng:'',
            Lat:'',
            Address:'',
            ContactsName:'',
            ContactsPhone:'',
            FullAddress:'',
          }
        }
      }
    }
  },
  mounted() {
    let that=this;
    Bus.$on('confirmMap',(data)=>{
      if(data && data.Lat){
        that.form.CityName=data.CityName;
        that.form.Lng=data.Lng;
        that.form.Lat=data.Lat;
        that.form.FullAddress=data.FullAddress;
      }
    })
  },
  methods: {
    pickMap(){
      this.$emit('openMap',this.form);
    },
    //提交
    submit(){
      if(this.form.FullAddress==''){
        this.$toast('请选择地址');
        return;
      }
      if(!this.form.ContactsName){
        this.$toast('请输入现场联系人');
        return;
      }
      if(!this.form.ContactsPhone){
        this.$toast('请输入现场联系人手机号');
        return;
      }
      if(!valid.phone(this.form.ContactsPhone) && this.form.ContactsPhone!=''){
        this.$toast('手机号格式不正确');
        return;
      }
      let params={
        ...this.form,
        platform:'pcweb',
      }
      if(this.userInfo && this.userInfo.LoginAccountType==1){
        params['UserId']=this.userInfo.LoginAccountId;
      }else if(this.userInfo && this.userInfo.LoginAccountType==2){
        params['CompanyId']=this.userInfo.LoginAccountId;
      }else{
        return;
      }
      if(this.editId){
        params['Id']=this.editId;
        UpdateJobAddress(params).then(r=>{
          this.$toast(r.Message);
          if(r.Result==1){
            this.$emit('success');
          }
        })
      }else{
        AddJobAddress(params).then(r=>{
          this.$toast(r.Message);
          if(r.Result==1){
            this.$emit('success');
          }
        })
      }
    },
  },
}
</script>
<style lang="scss">
.dialog-body .form-inner{
  &.form {
    width: 500px;
    margin: 20px auto 0;
    padding-bottom: 0px;
  }
  .form-item {
      position: relative;
      margin-bottom: 20px;
      overflow: hidden;
  }
  .input-box {
      min-height: 40px;
      position: relative;
      overflow: hidden;
      width: 400px;
      float: right;
  }
  .icon-location{
    position: absolute;
    right: 4px;
    top: 10px;
    font-size: 20px;
    color: #f75959;
  }
  .form-item .label {
      font-size: 14px;
      line-height: 24px;
      font-weight: bold;
      padding: 8px 0;
      color: #333;
      width: 100px;
      float: left;
      padding-right: 8px;
      text-align: right;
  }
  .form-item .input {
      width: 100%;
      height: 40px;
      border: 1px solid #e3e3e3;
      font-size: 14px;
      color: #333;
      padding: 8px 10px;
      line-height: 22px;
      &.address-input{
        padding-right: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
  }
    .btn-primary{
      display: block;
      width: 100px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #fff;
      background-color: #f75959;
      border-radius: 4px;
      text-align: center;
      margin: 30px auto 0;
    }
}
</style>